import { AbstractOperationMessage } from "./abstractOperationMessage";

export class ConfEmailMessage extends AbstractOperationMessage {
}